import { useState } from 'react';

import { Spin } from 'antd';

import PathForm from './path-form';

import TitledCard from '../../../layout-components/titled-card';

const NewPath: React.FC = () => {
  const [loading, setLoading] = useState(false);

  return (
    <Spin spinning={loading}>
      <TitledCard title="Nowa ścieżka zwiedzania" backUrl="..">
        <PathForm setLoading={setLoading} />
      </TitledCard>
    </Spin>
  );
};
export default NewPath;
